export interface SentryRuntimeFlagsInput {
  mode: 'development' | 'production' | 'test' | undefined;
  hasEnabledEnv: boolean;
  enabledFromEnv: boolean;
  hasSpotlightEnv: boolean;
  spotlightFromEnv: boolean;
}

export interface SentryRuntimeFlags {
  enabled: boolean;
  spotlightEnabled: boolean;
  /**
   * Whether to suppress the DSN so that no data reaches the remote Sentry
   * backend. In development the SDK stays active for Spotlight and feedback
   * dialog rendering, but the production DSN is withheld to prevent dev
   * errors from polluting the production Sentry project.
   */
  suppressDsn: boolean;
}

export function resolveSentryRuntimeFlags(input: SentryRuntimeFlagsInput): SentryRuntimeFlags {
  const isDevelopment = input.mode === 'development';
  const isTest = input.mode === 'test';
  const suppressDsn = isDevelopment || isTest;

  return {
    enabled: input.hasEnabledEnv ? input.enabledFromEnv : isDevelopment,
    spotlightEnabled: input.hasSpotlightEnv ? input.spotlightFromEnv : isDevelopment,
    // In development and test runtimes, always suppress DSN. The production
    // DSN lives in shared env files, but non-production errors must never
    // reach the production Sentry project.
    suppressDsn,
  };
}
